import { ILocationRequirement, LocationRequirement } from './location-requirement';
import { IVisaPermission, VisaPermission } from './visa-permission';

export interface ILocationAndVisas {
  location_requirements?: ILocationRequirement[];
  visas_permission_to_work?: IVisaPermission[];
}

export class LocationAndVisas {
  location_requirements: LocationRequirement[];
  visas_permission_to_work: VisaPermission[];

  constructor( data: ILocationAndVisas = {} ) {
    this.location_requirements = data.location_requirements
      ? data.location_requirements.map(( item ) => new LocationRequirement(item))
      : [];
    this.visas_permission_to_work = data.visas_permission_to_work
      ? data.visas_permission_to_work.map(( item ) => new VisaPermission(item))
      : [];
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/location-and-visas.ts